import React from "react"
import types from "prop-types"
import { useFormSubmissionScheduledReportExportContext } from "contexts/FormSubmissionScheduledReportExportContext"
import { Checkbox } from "components/shared/checkboxes"
import MassSelection from "shared/MassSelection"

const SelectAnswerFilterAnswerPicker = ({ questionUuid }) => {
  const {
    questions,
    selectAnswerFilters,
    setSelectAnswerFilterAnswers,
  } = useFormSubmissionScheduledReportExportContext()

  const question = questions.find((q) => q.uuid === questionUuid)
  const filter = selectAnswerFilters.find((f) => f.questionUuid === questionUuid)

  if (!question || !filter) return null

  const allAnswers = question.options ?? []

  const toggleAnswer = (answer) => {
    const current = filter.selectedAnswers
    const updated = current.includes(answer)
      ? current.filter((a) => a !== answer)
      : [...current, answer]
    setSelectAnswerFilterAnswers(questionUuid, updated)
  }

  return (
    <div className="border border-lightgray-3 rounded p-4">
      <p className="required-prompt mb-4">{question.prompt}</p>
      <MassSelection
        className="mb-4"
        selectAll={() => setSelectAnswerFilterAnswers(questionUuid, allAnswers)}
        deselectAll={() => setSelectAnswerFilterAnswers(questionUuid, [])}
      />
      {allAnswers.map((answer) => (
        <div key={answer} className="flex items-center">
          <Checkbox
            className="mr-2"
            onChange={() => toggleAnswer(answer)}
            uuid={`select-answer-checkbox-${questionUuid}-${answer}`}
            value={filter.selectedAnswers.includes(answer)}
          />
          <label className="hover:cursor-pointer" htmlFor={`select-answer-checkbox-${questionUuid}-${answer}`}>
            {answer}
          </label>
        </div>
      ))}
    </div>
  )
}

SelectAnswerFilterAnswerPicker.propTypes = {
  questionUuid: types.string.isRequired,
}

export default SelectAnswerFilterAnswerPicker
